import type { Dispatch, SetStateAction } from 'react'
import { useCallback } from 'react'

import BurgerMenu from '@/assets/icons/icon-menu.svg'
import { AgencyLogo } from '@/modules/accounts/ui/AgencyLogo/index.tsx'
import { CurrentCampaignPromotion } from '@/modules/campaigns/views/current-campaign-promotion.tsx'
import { useTheme } from '@/utils/useTheme.tsx'

import { HeaderMenu } from './header-menu.tsx'

interface HeaderProps {
  setCollapsed: Dispatch<SetStateAction<boolean>>
}

export const Header = ({ setCollapsed }: HeaderProps) => {
  const toggleSidebar = useCallback(() => {
    setCollapsed((toggleState) => !toggleState)
  }, [setCollapsed])
  const { blackFridayBannerOpen } = useTheme()

  return (
    <header
      className={`fixed inset-x-0 ${
        blackFridayBannerOpen ? 'top-[64px]' : 'top-[0px]'
      } bg-card z-50 flex h-[72px] flex-shrink-0 items-center justify-between gap-4 border-b px-4 sm:pl-8 lg:pr-16`}
    >
      <button
        onClick={toggleSidebar}
        className="active:bg-neutral-constract/50 text-title hover:bg-neutral-contrast dark:hover:bg-secondary-600 active:dark:bg-secondary-600/50 -m-2 cursor-pointer rounded-full p-2 lg:hidden"
      >
        <BurgerMenu />
      </button>
      <div
        className="hidden sm:block mr-auto"
        data-testid="agency-logo"
      >
        <AgencyLogo width={150} />
      </div>
      <CurrentCampaignPromotion />
      <HeaderMenu />
    </header>
  )
}
